<template>
    <!-- Self Made stepper (kinda xD) -->
    <div>
        <div class="stage-container">
            <a class="stage-name" :class="activePage(page)" 
            @click="setActivePage(page)"
            :href="'#'+page" v-for="page in pages" :key="page['index']">{{page}}</a>
        </div>
    </div>
</template>
<script>
export default {
    props:['pages', 'current'],
    data(){
        return{
            currentPage: ""
        }
    },
    methods:{
        activePage(page){
            return this.currentPage == page ? 'active' : '';
        },
        setActivePage(page){
            this.currentPage = page;
            this.activePage(page);
        }
    },
    watch:{
        current(){
            this.currentPage = this.current;
        }
    }

}
</script>

<style scoped>
    .stage-container{
        position: fixed;
        right: 5%;
        top: 20vh;
    }
    .stage-name{
        display: block;
        text-decoration: none;
        color: black;
        margin-top: 10px;
        background-color: rgba(0, 0, 0, 0.2);
        padding-top: 5px;
        text-align: center;
        width: 137px;
        height: 30px;
        border-radius: 5px;
    }
    .active{
        color: white; 
        background-color: #00368e;
    }
</style>

